import {
  defaultOperators as saasDefaultOperators,
  getDataGridFilter as baseGetDataGridFilter,
  FilterType,
  FilterOperatorId,
} from "@saas-ui-pro/react";
import {DateRange} from "./FiltersProvider";

const betweenDatesOperator = {
  id: "betweenDates" as FilterOperatorId,
  label: "betweeenDates",
  // https://github.com/saas-js/saas-ui-pro/issues/106
  types: ["date-range", "date-range-with-time"] as unknown as FilterType[],
  comparator(
    value: string | Date | undefined,
    filterValue: DateRange[] | undefined,
  ) {
    const dateRange = filterValue?.at(0);
    const startDate = dateRange?.startDate;
    const endDate = dateRange?.endDate;
    if (startDate && endDate && value) {
      if (value instanceof Date) {
        return startDate <= value && endDate >= value;
      }
      if (typeof value === "string") {
        const zonedDate = new Date(value);
        const dataDate = new Date(
          zonedDate.getUTCFullYear(),
          zonedDate.getUTCMonth(),
          zonedDate.getUTCDate(),
          zonedDate.getUTCHours(),
          zonedDate.getUTCMinutes(),
          zonedDate.getUTCSeconds(),
          zonedDate.getUTCMilliseconds(),
        );
        return startDate <= dataDate && endDate >= dataDate;
      }
    }
    return false;
  },
};

const lessThanOrEqualOperator = {
  id: "lessThanOrEqual" as FilterOperatorId,
  label: "less than or equal to",
  types: ["number"] as unknown as FilterType[],
  comparator(value: number, filterValue: number): boolean {
    if (value && filterValue) {
      return value <= filterValue;
    }
    return false;
  },
}

const greaterThanOrEqualOperator = {
  id: "greaterThanOrEqual" as FilterOperatorId,
  label: "greater than or equal to",
  types: ["number"] as unknown as FilterType[],
  comparator(value: number, filterValue: number): boolean {
    if (value && filterValue) {
      return value >= filterValue;
    }
    return false;
  },
}

const isEmptyOperator = {
  id: "isEmpty" as FilterOperatorId,
  label: "is empty",
  types: ["string"] as unknown as FilterType[],
  comparator(value: string, _filterValue: boolean): boolean {
    if (value) {
      return value.length === 0;
    }
    return false;
  },
}

const isNotEmptyOperator = {
  id: "isNotEmpty" as FilterOperatorId,
  label: "is not empty",
  types: ["string"] as unknown as FilterType[],
  comparator(value: string, _filterValue: boolean): boolean {
    if (value) {
      return value.length !== 0;
    }
    return false;
  },
}

export const defaultOperators = [...saasDefaultOperators, betweenDatesOperator, lessThanOrEqualOperator, greaterThanOrEqualOperator, isEmptyOperator, isNotEmptyOperator];

export const getDataGridFilter = <D extends object>(
  type: FilterType = "string",
  operators = defaultOperators,
) => baseGetDataGridFilter<D>(type, operators);
